import { getApiBaseUrl } from '@/config/env';

// API utility for admin dashboard
const API_BASE_URL = getApiBaseUrl();
const TENANT_ID = import.meta.env.VITE_TENANT_ID as string | undefined;

export const apiRequest = async (endpoint: string, options: RequestInit = {}) => {
  // Ensure endpoint starts with /
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const url = `${API_BASE_URL}${normalizedEndpoint}`;
  
  const defaultHeaders: HeadersInit = {
    'Content-Type': 'application/json',
    ...(TENANT_ID ? { 'x-tenant-id': TENANT_ID } : {}),
    ...options.headers,
  };

  const response = await fetch(url, {
    ...options,
    headers: defaultHeaders,
  });

  if (!response.ok) {
    throw new Error(`API request failed: ${response.status} ${response.statusText}`);
  }

  return response.json();
};

export const getWebSocketUrl = (token: string) => {
  const wsProtocol = API_BASE_URL.startsWith('https') ? 'wss:' : 'ws:';
  const baseUrl = API_BASE_URL.replace(/^https?:\/\//, '');
  return `${wsProtocol}//${baseUrl}/admin/monitoring/ws?token=${token}`;
};

export { API_BASE_URL, TENANT_ID };
